import firebase from "firebase/compat/app"
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";

const firebaseConfig = {
  apiKey: "AIzaSyD6J7W7ec-hAT-39Usuyltzbhhsot4_kYg",
  authDomain: "disney-plusv-4.firebaseapp.com",
  projectId: "disney-plusv-4",
  storageBucket: "disney-plusv-4.appspot.com",
  messagingSenderId: "848887532834",
  appId: "1:848887532834:web:bb6073eb5b6bc2c973297b",
  measurementId: "G-ELTH3T8JL7"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();
const storage = firebase.storage();

export { auth, provider, storage };
export default db;